import script from "./Contact.vue?vue&type=script&setup=true&lang=js"
export * from "./Contact.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=9bbefc42&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bbefc42"]])

export default __exports__